module.exports = __webpack_public_path__ + "static/media/lock.69f2db42.jpg";